import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { ListSettingsAPI, UpdateSettingAPI } from "./settings.api";

export const settingsKeys = {
  all: ["settings"],
  list: () => [...settingsKeys.all, "list"],
};

export const useSettingsListQuery = () =>
  useQuery({
    queryKey: settingsKeys.list(),
    queryFn: ListSettingsAPI,
  });

export const useUpdateSettingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: UpdateSettingAPI,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: settingsKeys.list() });
    },
  });
};
